function sanitizeText(text) {
    if (!text) return text;
    return text.replace(/\n/g, ' ');
}
export { sanitizeText };
